import React from 'react';
import { mapModifiers } from 'libs/component';
import { Tabs } from 'components/molecules/tabs';
import { useTranslation } from 'react-i18next';

export const HowGettingHere: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className={mapModifiers('o-getting-here', i18n.language)}>
      <Tabs
        current={0}
        tabs={[
          { icon: 'mrt', children: <span>{t('home.how-getting-here.mrt.title')}</span> },
          { icon: 'bts', children: <span>{t('home.how-getting-here.bts.title')}</span> },
          { icon: 'bus', children: <span>{t('home.how-getting-here.bus.title')}</span> },
          { icon: 'car', children: <span>{t('home.how-getting-here.car.title')}</span> },
          { icon: 'plane', children: <span>{t('home.how-getting-here.airport.title')}</span> },
        ]}
      >
        <div className="o-getting-here__item o-getting-here__item--mrt">
          <div className="o-getting-here__item-logo">
            <img src="/images/bus-route/getting.png" width="100%"></img>
          </div>
          <div
            className="o-getting-here__item-text"
            dangerouslySetInnerHTML={{
              __html: t('home.how-getting-here.mrt.description'),
            }}
          />
        </div>
        <div className="o-getting-here__item o-getting-here__item--bts">
          <div className="o-getting-here__item-logo">
            <img src="/images/bus-route/bts.png" width="100%"></img>
          </div>
          <div
            className="o-getting-here__item-text"
            dangerouslySetInnerHTML={{
              __html: t('home.how-getting-here.bts.description'),
            }}
          />
        </div>
        <div className="o-getting-here__item o-getting-here__item--bus">
          <div className="o-getting-here__item-logo">
            <img src="/images/bus-route/bus.png" width="100%"></img>
          </div>
          <div
            className="o-getting-here__item-text"
            dangerouslySetInnerHTML={{
              __html: t('home.how-getting-here.bus.description'),
            }}
          />
        </div>
        <div className="o-getting-here__item o-getting-here__item--car">
          <div className="o-getting-here__item-logo">
            <img src="/images/bus-route/car.png" width="100%"></img>
          </div>
          <div
            className="o-getting-here__item-text"
            dangerouslySetInnerHTML={{
              __html: t('home.how-getting-here.car.description'),
            }}
          />
          
        </div>
        <div className="o-getting-here__item o-getting-here__item--airport">
          <div className="o-getting-here__item-logo">
            <img src="/images/bus-route/airport.png" width="100%"></img>
          </div>
          <div
            className="o-getting-here__item-text"
            dangerouslySetInnerHTML={{
              __html: t('home.how-getting-here.airport.description'),
            }}
          />
        </div>
        
      </Tabs>
    </div>
  );
};
